import React from 'react';
import PropTypes from 'prop-types';

import EmailStatus from '../../email-status';

const EmailStatusFormatter = ({ value }) => <EmailStatus status={value} />;

EmailStatusFormatter.propTypes = {
    value: PropTypes.string
};

export default EmailStatusFormatter;



// WEBPACK FOOTER //
// ./app/components/formatters/email-status-formatter/index.js